import { useState } from "react";

export default function useShowPassword() {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  return { handleClickShowPassword, showPassword };
}
